import { EncryptedDto } from '@dtos/encrypted-dto';
import CipherService from '@services/cipher-service';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';

export interface IPersonPidEncryptionService {
    decryptDto(encryptedPid?: EncryptedDto): string;
    encryptDto(value: string): EncryptedDto;
}

export enum PersonPidEncryptionError {
    EncryptionFailure = 'Failed to encrypt pid'
}

export class PersonPidEncryptionService implements IPersonPidEncryptionService {
    constructor(
        private configurationValuesService: IConfigurationValuesService
    ) {
    }

    decryptDto(encryptedPid?: EncryptedDto): string {
        const { personPidKey } = this.configurationValuesService;

        if (!encryptedPid?.iv || !encryptedPid?.cipherText) {
            return '';
        }

        return CipherService.decryptAes(
            encryptedPid.cipherText,
            encryptedPid.iv,
            personPidKey
        ) ?? '';
    }

    encryptDto(value: string): EncryptedDto {
        const {
            personPidKey,
            personPidIvLength
        } = this.configurationValuesService;

        const encrypted = CipherService.encryptAes(
            value,
            personPidKey,
            personPidIvLength
        );

        if (!encrypted) {
            throw new Error(PersonPidEncryptionError.EncryptionFailure);
        }

        return {
            cipherText: encrypted.cipher,
            iv: encrypted.initializationVector
        };
    }
}



// WEBPACK FOOTER //
// ./src/services/onboarding-review/person-pid-encryption-service.ts